
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/what-we-store",
      function () {
        return require("private-next-pages/what-we-store/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/what-we-store"])
      });
    }
  